import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { ɵFormGroupValue, ɵTypedOrUntyped } from '@angular/forms';
import { IPhotoForm } from '@curbnturf/form-helpers';
import { IPhoto } from '@curbnturf/objects';
import { IonicModule, ModalController } from '@ionic/angular';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';

@Component({
  selector: 'curbnturf-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.scss'],
  standalone: true,
  imports: [DeleteModalComponent, IonicModule, NgIf, NgTemplateOutlet],
})
export class DeleteConfirmationModalComponent {
  @Input() photo: IPhoto | ɵTypedOrUntyped<IPhotoForm, ɵFormGroupValue<IPhotoForm>, any>;
  @Input() name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() deleteFunction: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() template: TemplateRef<any>;

  modal: HTMLIonModalElement;

  constructor(private modalController: ModalController) {}

  async openModal() {
    this.modal = await this.modalController.create({
      component: DeleteModalComponent,
      componentProps: {
        photo: this.photo,
        name: this.name,
        closeFunction: () => this.closeFunction(),
        deleteFunction: () => this.confirm(),
      },
      cssClass: 'confirm-modal center',
    });
    await this.modal.present();
  }

  async confirm(): Promise<void> {
    this.deleteFunction();

    await this.closeFunction();
  }

  async closeFunction(): Promise<void> {
    await this.modal.dismiss();
  }
}
